import React from "react";
import styled from "styled-components";
import { Icon } from "@vds/icons";

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 8px;
  align-items: flex-start;
`;

const Bubble = styled.div`
  padding: 10px 18px;
  border-radius: 20px;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  display: inline-block;
  max-width: 75%;
  font-size: 17px;
  line-height: 1.5;
  color: #1a1a1a;
  word-break: break-word;
`;

const StarButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 4px;
  transition: background-color 0.15s ease;
  color: ${({ $isFavorited }) => ($isFavorited ? "#cd040b" : "#9ca3af")};

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: ${({ $isFavorited }) => ($isFavorited ? "#a00308" : "#6b7280")};
  }
`;

const Spinner = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid #d1d5db;
  border-top-color: #1a1a1a;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 8px;
  animation: spin 0.7s linear infinite;

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;

export default function UserMessage({ message, onToggleFavorite, isFavorited, isPending }) {
  return (
    <Wrapper data-testid="user-message">
      {onToggleFavorite && (
        isPending ? (
          <Spinner />
        ) : (
          <StarButton
            $isFavorited={isFavorited}
            onClick={() => onToggleFavorite(message.content)}
            aria-label={isFavorited ? "unfavorite" : "favorite"}
          >
            <Icon
              name={isFavorited ? "added-to-favorite" : "add-to-favorite"}
              size="small"
            />
          </StarButton>
        )
      )}
      <Bubble>{message.content}</Bubble>
    </Wrapper>
  );
}
